import { flowKindColor } from './flowColors'
import { type LaidOutFlowLink, LEGEND_BASELINE, textWidth } from './flowLayout'
import { FLOW_KINDS, flowKindLabel } from './flowModel'

const SWATCH_WIDTH = 14
const SWATCH_HEIGHT = 8
const SWATCH_GAP = 6
const ITEM_GAP = 20

// Drawn inside the svg so report exports keep the key with the chart.
export function FlowLegend({ links }: { links: LaidOutFlowLink[] }) {
  const shownKinds = FLOW_KINDS.filter((kind) =>
    links.some((link) => link.kind === kind),
  )
  let x = 0
  const items = shownKinds.map((kind) => {
    const item = { kind, x, label: flowKindLabel(kind) }
    x += SWATCH_WIDTH + SWATCH_GAP + textWidth(item.label.length) + ITEM_GAP
    return item
  })
  return (
    <g className="pointer-events-none select-none">
      {items.map((item) => (
        <g key={item.kind} transform={`translate(${item.x}, 0)`}>
          <rect
            y={LEGEND_BASELINE - SWATCH_HEIGHT}
            width={SWATCH_WIDTH}
            height={SWATCH_HEIGHT}
            rx={2}
            fill={flowKindColor(item.kind)}
            fillOpacity={0.6}
          />
          <text
            x={SWATCH_WIDTH + SWATCH_GAP}
            y={LEGEND_BASELINE}
            fontSize={11}
            className="fill-muted-foreground"
          >
            {item.label}
          </text>
        </g>
      ))}
    </g>
  )
}
